import React from 'react'
import { useContext } from '../Context'
import { PopUpContainer } from '../../../../components/header/quick-create/PopUpContainer'
import { MenuPopUpEnum } from '../MenuPopUpEnum'
import { AddNewFromConversationForm } from '../../../../components/AddOrder/AddNewFromConversationForm'

export const OrderFromConversationPopUp = () => {
  const { menuTarget, onSuccessSubmit } = useContext()

  return (
    <PopUpContainer show={menuTarget?.show === MenuPopUpEnum.orderFromConversation} target={menuTarget?.target}>
      <AddNewFromConversationForm onSuccessSubmit={onSuccessSubmit} />
    </PopUpContainer>
  )
}
